module.exports = __webpack_public_path__ + "static/android-chrome-192x192-f1a79a81570cb208d4ac62f84436a708.png";